import { TailwindColors } from '../../../../common/constants/tailwind-colors';

/**
 * Presentational configuration for the Refresh cache navbar button.
 * Extracted to allow reuse (e.g., in the mock dashboard backdrop) without
 * importing the full registry service, which would create a cycle.
 */

/**
 * Appearance-only properties for the Refresh cache button.
 * Spread into the registry's registerButton call; the registry overlays
 * behavior (id, visibleOnRoutes, order, isDisabled, computed options, onOptionSelected).
 */
export const REFRESH_CACHE_BUTTON_APPEARANCE = {
  label: 'Refresh cache',
  level: 'primary' as const,
  icon: 'sync',
  iconSize: '24px',
  iconPosition: 'left' as const,
  useMatIcon: true,
  fontColor: TailwindColors.primaryBlack,
  fontWeight: 700,
  fontSize: '14px',
  fontFamily: 'Roboto',
  borderColor: TailwindColors.primaryBlack,
  iconColor: TailwindColors.tertiaryBlueCta,
  buttonWidth: '180px',
  panelWidth: '260px',
  panelPosition: 'before' as const,
  mode: 'standard' as const,
};

/**
 * Static label/value pairs for the two Refresh cache options.
 * The registry overlays computed disabled/tooltip onto these.
 */
export const REFRESH_CACHE_OPTIONS_BASE = [
  { label: 'Refresh All', value: 'refresh-all' },
  { label: 'Refresh Selected', value: 'refresh-selected' },
] as const;
